var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"absolute":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"color":_vm.value,"dark":"","block":""}},on))]}}])},[_c('v-color-picker',{staticClass:"mx-auto",attrs:{"value":_vm.value},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }